// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "PageTabs-module--bx--text-truncate--end--1i3YZ";
export var bxTextTruncateFront = "PageTabs-module--bx--text-truncate--front--16QtI";
export var link = "PageTabs-module--link--NRtef";
export var list = "PageTabs-module--list--1kwNv";
export var listItem = "PageTabs-module--list-item--Iy7tm";
export var selectedItem = "PageTabs-module--selected-item--18GsE";
export var tabsContainer = "PageTabs-module--tabs-container--3frXa";